module.exports = __webpack_public_path__ + "img/locked-icon.3949d500.svg";